import { Component, Input } from '@angular/core';
import { ModalSize } from '@d-constants';
import { RevisionHistoryModalComponent } from './revision-history-modal/revision-history-modal.component';
import { ModalService } from '@d-services';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { CustomPipesModule } from '@d-pipes/pipes.module';

@Component({
  selector: 'app-revision-history',
  templateUrl: './revision-history.component.html',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    RevisionHistoryModalComponent,
    CustomPipesModule,
  ],
})
export class RevisionHistoryComponent {
  @Input() config: any = {};

  constructor(
    protected modalService: ModalService,
    private translateService: TranslateService,
  ) {}

  openRevisionHistoryModal() {
    this.modalService.openModal(RevisionHistoryModalComponent, {
      title: this.translateService.instant('REVISION_HISTORY'),
      size: ModalSize.LARGE,
      data: {
        loadData: this.config.loadData,
      },
    });
  }
}
